const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  id: (lambdaParameter, value) => `${lambdaParameter}.Id.Equals("${value}")`,
  printLayoutId: (lambdaParameter, value) =>
    `${lambdaParameter}.PrintLayoutId==${value}`,
  text: (lambdaParameter, value) =>
    `${lambdaParameter}.Text.Contains("${value}")`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
